import { render } from "./DocumentListView.vue?vue&type=template&id=01b665a2&scoped=true&ts=true"
import script from "./DocumentListView.vue?vue&type=script&lang=ts"
export * from "./DocumentListView.vue?vue&type=script&lang=ts"

import "./DocumentListView.vue?vue&type=style&index=0&id=01b665a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b665a2"]])

export default __exports__